<template>
  <social-link :href="link" target="_blank" :fillcolor="color">
    <div class="wrapper">
      <svg viewBox="0 0 32 32" width="32" height="32">
        <title>twitch</title>
        <g :fill="color">
          <path d="M3.687,1,1.672,6.149V27H9v4h3.866l3.806-4h5.821l7.835-7.642V1ZM27.642,18.015l-4.478,4.478H16L12,26.3V22.493H6V3.687H27.642Z" :fill="color"></path>
          <rect x="20" y="9" width="3" height="8"></rect> <rect x="13" y="9" width="3" height="8"></rect>
        </g>
      </svg>
    </div>
  </social-link>
</template>

<script>
import { SocialLink } from '@/styles/components'

export default {
  components: {
    SocialLink
  },
  props: [
    'link',
    'color'
  ]
}
</script>
